/**
 * Web stand-in for react-native-restart.
 * On web we force RTL via document.dir instead of relaunching the app.
 */
const RNRestart = {
  restart(): void {
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  },
  /** @deprecated use restart() */
  Restart(): void {
    RNRestart.restart();
  },
  async getReason(): Promise<string> {
    return '';
  },
};

export default RNRestart;
